import React from 'react';
import { User, Scissors, ArrowUpRight, Zap, CheckCircle2 } from 'lucide-react';

const SuccessCases: React.FC = () => {
  const cases = [
    {
      icon: User,
      title: "Clínica Dental Elite",
      stat: "+45%",
      statLabel: "Incremento en Citas",
      desc: "Implementación de sistema de reservas 100% automático. El bot califica al paciente, ofrece horarios disponibles en tiempo real y confirma la cita en Google Calendar.",
      tags: ["WhatsApp API", "Google Calendar", "Recuperación de Leads"],
      color: "text-cyan-400",
      bgGlow: "group-hover:shadow-[0_0_40px_rgba(34,211,238,0.2)]",
      borderGlow: "group-hover:border-cyan-400/50"
    },
    {
      icon: Scissors,
      title: "Barbería Royal Cut",
      stat: "0%",
      statLabel: "Tasa de Ausentismo",
      desc: "Antes perdían el 20% de ingresos por inasistencias. Ahora, el bot solicita un abono automático para confirmar y envía recordatorios 2 horas antes.",
      tags: ["Pagos Automáticos", "n8n", "Gestión de Agenda"],
      color: "text-purple-400",
      bgGlow: "group-hover:shadow-[0_0_40px_rgba(192,132,252,0.2)]",
      borderGlow: "group-hover:border-purple-400/50"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-mira-bg to-mira-surface relative overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-mira-border to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-3 py-1 rounded-full border border-mira-accent/30 bg-mira-accent/5 mb-4 shadow-[0_0_15px_rgba(26,140,255,0.2)]">
            <Zap className="w-3 h-3 text-mira-accent mr-2" />
            <span className="text-xs font-bold text-mira-accent tracking-widest uppercase drop-shadow-[0_0_5px_rgba(26,140,255,0.6)]">Resultados Comprobados</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6 text-white tracking-tight">
            Transformamos Negocios <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-mira-accent to-purple-400 drop-shadow-[0_0_15px_rgba(26,140,255,0.3)]">Reales</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg font-medium">
            No es solo código, es rentabilidad. Mira el impacto directo de la automatización en nuestros clientes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {cases.map((item, index) => (
            <div 
              key={index} 
              className={`group relative bg-mira-bg border border-mira-border rounded-3xl p-8 md:p-10 transition-all duration-500 hover:-translate-y-2 ${item.bgGlow} ${item.borderGlow}`}
            >
              {/* Header */}
              <div className="flex justify-between items-start mb-8">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 rounded-2xl bg-mira-surface border border-mira-border flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <item.icon className={`w-8 h-8 ${item.color}`} />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-gray-300 transition-all">
                      {item.title}
                    </h3>
                    <div className="flex items-center gap-1 text-gray-500 text-sm mt-1">
                       <CheckCircle2 className="w-3 h-3 text-green-500" />
                       <span>Caso Verificado</span>
                    </div>
                  </div>
                </div>
                <ArrowUpRight className={`w-8 h-8 text-gray-600 group-hover:text-white transition-colors duration-300`} />
              </div>

              {/* Main Metric */}
              <div className="mb-8 py-6 border-y border-dashed border-gray-800 group-hover:border-gray-600 transition-colors">
                 <div className="flex items-end gap-3">
                    <span className={`text-6xl font-black ${item.color} leading-none tracking-tight drop-shadow-[0_0_10px_rgba(255,255,255,0.1)]`}>{item.stat}</span>
                    <span className="text-gray-400 font-medium mb-2 text-lg">{item.statLabel}</span>
                 </div>
              </div>

              {/* Description */}
              <p className="text-gray-300 text-lg leading-relaxed mb-8">
                {item.desc}
              </p>

              {/* Tags */}
              <div className="flex flex-wrap gap-2">
                {item.tags.map((tag, i) => (
                  <span 
                    key={i} 
                    className="px-4 py-2 rounded-lg bg-mira-surface border border-mira-border text-xs font-semibold text-gray-400 group-hover:text-white group-hover:border-mira-accent/30 transition-all"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessCases;